import { Component, OnInit } from '@angular/core';
import {CONSTANTS} from '../../../constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }
  public CONSTANTS = CONSTANTS;

  copyYear = (new Date()).getUTCFullYear()

  ngOnInit(): void {
  }

}
